import { HeroSection } from './Components/HeroSection';
import { HowItWorks } from './Components/HowItWorks';
import { Benefits } from './Components/Benefits';
import { Sectors } from './Components/Sectors';
import { AboutUs } from './Components/AboutUs';
import { ActionBar } from './Components/ActionBar';
import HalftoneMarquee from './Components/HalftoneMarquee';
import bindflowLogo from "./Assets/bindflow_logo.png";

function App() {
  return (
    <div className="App">
      <div className='bg bg-blue'>
        <HeroSection />
        <HowItWorks />
        <Benefits />
      </div>
      <ActionBar />
      <div className='bg bg-orange'>
        <Sectors />
        <HalftoneMarquee />
        <AboutUs />
        <div className='created'>
          <p>Created by</p>
          <img src={bindflowLogo} alt="" />
        </div>
      </div>
    </div>
  );
}

export default App;
